import { render, staticRenderFns } from "./_seller_group.form.vue?vue&type=template&id=737c4568&scoped=true&"
import script from "./_seller_group.form.vue?vue&type=script&lang=js&"
export * from "./_seller_group.form.vue?vue&type=script&lang=js&"
import style0 from "./_seller_group.form.vue?vue&type=style&index=0&id=737c4568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c4568",
  null
  
)

export default component.exports